import { DiagnosticCode } from '../../../../DiagnosticCode';
import { DiagnosticMessage } from '../../../../DiagnosticMessage';
import { BuiltinMemberValue } from '../../BuiltinMemberValue';
import { isConstructorParameterDefault } from './isConstructorParameterDefault';
export class DeploySenderAddress extends BuiltinMemberValue {
    emit(sb, node, options) {
        if (!isConstructorParameterDefault(node)) {
            sb.context.reportError(node, DiagnosticCode.InvalidSenderAddress, DiagnosticMessage.InvalidSenderAddressParameterUsage);
        }
        if (options.pushValue) {
            sb.emitPushBuffer(node, Buffer.alloc(20, 0));
            sb.emitHelper(node, options, sb.helpers.wrapBuffer);
        }
    }
}

//# sourceMappingURL=senderAddress.js.map
